import { StyleSheet, TouchableOpacity } from 'react-native';
import Animated from 'react-native-reanimated';
import { Ionicons } from '@expo/vector-icons';

const AnimatedTouchable = Animated.createAnimatedComponent(TouchableOpacity);

export type CoverImageEditButtonProps = {
  onPress: () => void;
  animatedStyle: any;
};

/**
 * CoverImageEditButton - Small semi-transparent circular button with camera icon.
 * Positioned at top-right of the header, below the status bar. Fades out as header collapses.
 */
export function CoverImageEditButton({ onPress, animatedStyle }: CoverImageEditButtonProps) {
  return (
    <AnimatedTouchable
      style={[styles.button, animatedStyle]}
      onPress={onPress}
      activeOpacity={0.7}
      hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
    >
      <Ionicons name="camera-outline" size={20} color="#888888" />
    </AnimatedTouchable>
  );
}

const styles = StyleSheet.create({
  button: {
    opacity: 0.7,
    padding: 4,
  },
});
